/* (ignored) */


//////////////////
// WEBPACK FOOTER
// path (ignored)
// module id = 47
// module chunks = 0 1